import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  empType,
  JunctionStatus,
  LicenseTypes,
  Operation,
  PageFor,
  PriorityEnum,
  TableHeaders,
} from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import {
  GridAlignment,
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AtsSubsidiaryOrderField } from "../queries/types";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyFunc,
  emptyMessage,
} from "../../../../../../utils/constants";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../../utils/types";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../../styles/Variables";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
  ticketPriorityClassName,
} from "../../../../../../utils/UtilFunctions";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import Edit from "../../../../../../images/EditProfile.svg";
import Delete from "../../../../../../images/Delete.svg";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import { Title } from "../../../../../../stories/Title/Title";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import Close from "../../../../../../images/Close.svg";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../../../../pages/LoadingModal";
import MessageModal from "../../../../../../customComponents/MessageModal";
import Navbar from "../../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../../utils/hotKeys";
import { Keys, SpecialKeys } from "../../../../../../utils/Enum.keys";
import useLabels from "../../../../../../customHooks/useLabels";
import { GetJunctions } from "./queries/queries";
import {
  DeleteJunctionResult,
  DeleteJunctionVars,
  GetJunctionsData,
  GetJunctionsVars,
  JunctionEdge,
} from "./queries/types";
import { DeleteJunction } from "./queries/mutations";
import AddJunctions from "./AddJunction";
import {
  CustomModalStyles,
  PrintModalStyles,
  ViewAssetStyles,
} from "../../../../../../styles/CustomModalStyles";
import Input from "../../../../../../stories/Input/Input";
import ImportJunctions from "./ImportJunctions";
import Next from "../../../../../../images/Assign.svg";
import CompaniesAutocomplete from "../../../../customer/companies/CompaniesAutocomplete";
import SubsidiarySelect from "../../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import MultipleJunctionTypesAutocomplete from "../../../../../../customComponents/JunctionTypesAutcomplete";
import MultipleJunctionPrioritySelect from "../../../../../../customComponents/JunctionPriorityAutocomplete";
import ParticuarJunctionDetails from "./ParticuarJunctionDetails";
import SuppliersAutocomplete from "../../../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { LdgrQueryType } from "../../supplier/queries/types";
import { TableType } from "../../../../customer/companies/queries/types";
import { Checkbox, TextField } from "@mui/material";
import PrintJunctionDetails from "./PrintJunctionDetails";
import {
  LabeledAutocomplete,
  labelClasses,
} from "../../../../../../styles/AutocompleteStyles";
export interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export interface CustomModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  contentComponent: React.ReactNode;
}

export interface StateTypes {
  junctionId: number[];
  flag: boolean;
}

const Junctions = ({ setModalFlag, pageType }: Props) => {
  const {
    junctionLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    companyLabel,
    ledgerLabel,
  } = useLabels();

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [junctions, setJunctions] = useState<JunctionEdge[]>([]);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [message, setMessage] = useState(emptyMessage);
  const [importModal, setImportModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [junctionStatus, setJunctionStatus] = useState<JunctionStatus | null>();
  const [printModal, setPrintModal] = useState(false);
  const [print, setPrint] = useState(false);

  const [viewModal, setViewModal] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [selectJunctionTypes, setSelectJunctionTypes] = useState<string[]>([]);
  const [selectedPriority, setSelectedPriority] = useState<PriorityEnum[]>([]);
  const [selectedJunctions, setSelectedJunctions] = useState<number[]>([]);

  const { customer_id, sub_id, siteID, company_id } = useUrlParams();
  const { JunctionsTable } = useAssetTableJson();
  const { state, dispatch } = useContext(AppContext);
  const { user_details } = useLoggedInUserDetails();
  const statusOptions = Object.values(JunctionStatus);

  const navigate = useNavigate();

  const [getJunctions, { data, loading, fetchMore }] = useLazyQuery<
    GetJunctionsData,
    GetJunctionsVars
  >(GetJunctions);

  const [deleteJunction, { loading: DeleteSubsidiarySiteLoading }] =
    useMutation<DeleteJunctionResult, DeleteJunctionVars>(DeleteJunction, {
      onError: (e) => {
        setMessage({
          message: e.message,
          flag: true,
          operation: Operation.NONE,
        });
      },
    });

  useEffect(() => {
    if (customer_id) {
      getJunctions({
        variables: {
          after: null,
          customerID: customer_id,
          companyID: company_id
            ? company_id
            : state.companyId
            ? state.companyId
            : 0,
          first: ROWS_PER_PAGE,
          empID: user_details.id,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsSubsidiaryOrderField.NAME,
          },
          priority: selectedPriority,
          jType: selectJunctionTypes.length
            ? selectJunctionTypes
            : state.junctionType
            ? [state.junctionType]
            : [],
          name: searchData,
          subsidiaryID: sub_id
            ? sub_id
            : state.subsidiaryId
            ? state.subsidiaryId
            : 0,
          siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
          ldgrID: state.supplierId ? state.supplierId : 0,
          junctionStatus: junctionStatus ? [junctionStatus] : undefined,
        },
      });
    }
  }, [
    getJunctions,
    customer_id,
    company_id,
    sub_id,
    state.companyId,
    state.subsidiaryId,
    state.subSiteId,
    user_details.id,
    state.junctionType,
    siteID,
    searchData,
    state.supplierId,
    selectedPriority,
    selectJunctionTypes,
    junctionStatus,
  ]);

  const dynamicHeaders: TableHeaderProps[] = JunctionsTable.List.map(
    (header) => ({
      headerName: header.headerName,
      className: header.cellClassName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (params.field === "priority") {
          return (
            <>
              <div
                className={ticketPriorityClassName(params.row.priority)}
                style={{ margin: "auto" }}
              >
                {params.row.priority}
              </div>
            </>
          );
        } else return params.row.value;
      },
    })
  );
  const actions: GridColDef = {
    field: "actions",
    cellClassName: "td-status ",
    headerAlign: HEADER_TEXT_ALIGN,
    align: MARKS_TEXT_ALIGN,
    headerName: TableHeaders.ACTION,
    renderCell: (params) => {
      return (
        <>
          <img
            src={Edit}
            alt=""
            onClick={() => {
              dispatch({
                type: payloadTypes.SET_JUNCTION_ID,
                payload: {
                  junctionID: params.row.junctionID,
                },
              });

              setEditModal(!editModal);
              // navigate(
              //   `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/site/${siteID}/junctions/${params.row.junctionID}/update`
              // );
            }}
          />
          <img
            src={Delete}
            alt="/"
            onClick={() => {
              dispatch({
                type: payloadTypes.SET_JUNCTION_ID,
                payload: {
                  junctionID: params.row.junctionID,
                },
              });
              setDeleteModal(!deleteModal);
            }}
          />
        </>
      );
    },
  };

  const columns: GridColDef[] = [
    ...(print
      ? [
          {
            headerName: "Select All",

            field: "select_all",
            flex: FlexForColumns.ACTION,
            headerAlign: HEADER_TEXT_ALIGN,
            align: MARKS_TEXT_ALIGN,
            renderCell: (params: GridRenderCellParams) => {
              return (
                <>
                  <Checkbox
                    checked={selectedJunctions.includes(params.row.junctionID)}
                    onChange={() => {
                      handleCheckboxChange(params.row.junctionID);
                    }}
                  />
                </>
              );
            },
            renderHeader: (params: GridColumnHeaderParams) => {
              return (
                <>
                  <Checkbox
                    checked={
                      data
                        ? selectedJunctions.length ===
                          data.GetJunctions.edges.filter(
                            (res) => res.node.id !== state.junctionID
                          ).length
                        : false
                    }
                    onChange={handleSelectAll}
                  />
                  Select All
                </>
              );
            },
          },
        ]
      : []),
    ...dynamicHeaders,
    actions,
  ];

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetJunctions.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = junctions.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setJunctions(updatedNewData);
      } else {
        setJunctions(newData);
      }

      setEndCursor(data.GetJunctions.pageInfo.endCursor);
      setHasNextPage(data.GetJunctions.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [data, loading]);

  const rows = useMemo(() => {
    return data
      ? data.GetJunctions.edges.map(({ node }, index) => ({
          id: index + 1,
          junction_name: node.name,
          junctionID: node.id,
          priority: node.priority,
          code: node.code,
          vendorDetails: node.vendorDetails.desc,
          alias: node.alias,
          jType: node.jType,
          arms: node.arms,
          poles: node.poles,
          junctionStatus: node.junctionStatus,
        }))
      : [];
  }, [data]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetJunctions.edges;
          const pageInfo = fetchMoreResult.GetJunctions.pageInfo;
          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetJunctions.edges.filter(
            ({ node: { id } }) =>
              newEdges.findIndex(({ node: { id: newId } }) => newId === id) !==
              -1
          );

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetJunctions: {
              edges: [...junctions, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetJunctions.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  const HandleDelete = async () => {
    try {
      setDeleteModal(false);
      if (state.junctionID) {
        await deleteJunction({
          variables: {
            user_details,
            junctionID: state.junctionID,
          },
          refetchQueries: [
            {
              query: GetJunctions,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id
                  ? company_id
                  : state.companyId
                  ? state.companyId
                  : 0,
                first: ROWS_PER_PAGE,
                empID: user_details.id,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },
                priority: [],
                jType: [],
                name: searchData ? searchData : EMPTY_STRING,
                subsidiaryID: sub_id
                  ? sub_id
                  : state.subsidiaryId
                  ? state.subsidiaryId
                  : 0,
                siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
                ldgrID: state.supplierId ? state.supplierId : 0,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.DeleteJunction) {
            setMessage({
              flag: true,
              message: "Deleted Successfully",
              operation: Operation.DELETE,
            });
          }
        });
      }
    } catch (error) {}
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedJunctions((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (data) {
      const allIds = data.GetJunctions.edges
        .filter((res: JunctionEdge) => res.node.id !== state.junctionID)
        .map((res: JunctionEdge) => res.node.id);

      if (selectedJunctions.length === allIds.length) {
        setSelectedJunctions([]); // Deselect all
      } else {
        setSelectedJunctions(allIds); // Select all
      }
    }
  };

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar
          NavType={
            state.empSubType !== empType.PMU
              ? LicenseTypes.COMPANY
              : LicenseTypes.DASHBOARD
          }
        />
      )}

      <div className="junctions__title">
        <Title>{junctionLabel}</Title>
        {pageType === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        )}
      </div>

      <div
        className={`junctions${pageType === PageFor.GENERAL ? "" : "__modal"}`}
      >
        <div className="junctions__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          {company_id ? null : (
            <div className="col">
              <CompaniesAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                value={state.companyId ? state.companyId : 0}
                label={companyLabel}
              />
            </div>
          )}
          {sub_id ? null : (
            <div className="col">
              <SubsidiarySelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                companyID={state.companyId ? state.companyId : 0}
                value={state.subsidiaryId ? state.subsidiaryId : 0}
                label={subsidiaryLabel}
              />
            </div>
          )}
          {siteID ? null : (
            <div className="col">
              <SiteSelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                  }
                }}
                companyId={state.companyId ? state.companyId : 0}
                subsidiaryId={state.subsidiaryId ? state.subsidiaryId : 0}
                onKeyDown={emptyFunc}
                value={state.subSiteId ? state.subSiteId : 0}
                label={subsidiarySiteLabel}
              />
            </div>
          )}
          <div className="col">
            <MultipleJunctionTypesAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  setSelectJunctionTypes(newValue);
                } else {
                  setSelectJunctionTypes([]);
                }
              }}
              onKeyDown={emptyFunc}
              autoCompleteValue={selectJunctionTypes}
              label="Junction Type"
              handleClear={emptyFunc}
            />
          </div>
          <div className="col">
            <MultipleJunctionPrioritySelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedPriority(newValue);
                } else {
                  setSelectedPriority([]);
                }
              }}
              onKeyDown={emptyFunc}
              autoCompleteValue={selectedPriority}
              label="Priority"
              handleClear={emptyFunc}
            />
          </div>
          <div className="col">
            <SuppliersAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: newValue.value as number,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: 0,
                    },
                  });
                }
              }}
              onKeyDown={() => {}}
              value={state.supplierId ? state.supplierId : 0}
              label={`${ledgerLabel}`}
              input={{
                itemID: 0,
                query_type: LdgrQueryType.ALL,
                tableLevel: TableType.JUNCTION,
              }}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={statusOptions}
              value={junctionStatus}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setJunctionStatus(newValue as JunctionStatus);
                } else {
                  setJunctionStatus(null);
                }
              }}
              openOnFocus
              forcePopupIcon
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Status"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col flex-end">
            {state.empSubType === empType.SYS_ADMIN ||
            state.empSubType === empType.PMU ? (
              <Button
                mode="addnew"
                onClick={() => {
                  setAddModal(!addModal);
                }}
              />
            ) : null}
          </div>
        </div>
        <div className="junctions__tableblock">
          <StyledDatagrid
            columns={
              state.empSubType === empType.SYS_ADMIN
                ? columns
                : state.empSubType === empType.PMU
                ? [...dynamicHeaders, actions]
                : dynamicHeaders
            }
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (
                state.empSubType === empType.SYS_ADMIN ||
                state.empSubType === empType.PMU
              ) {
                if (
                  params.field === "junction_name" &&
                  pageType === PageFor.GENERAL
                ) {
                  if (state.empSubType === empType.SYS_ADMIN)
                    navigate(`${params.row.junctionID}/itemslist`);
                  else {
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: { junctionID: params.row.junctionID },
                    });
                    setViewModal(!viewModal);
                  }
                } else if (
                  params.field === "junction_name" &&
                  pageType === PageFor.MODAL
                ) {
                  dispatch({
                    type: payloadTypes.SET_JUNCTION_ID,
                    payload: { junctionID: params.row.junctionID },
                  });
                  setViewModal(!viewModal);
                }
              }
            }}
            disableRowSelectionOnClick
            hideFooter
            onRowsScrollEnd={handleScroll}
          />
        </div>
        <div className="row g-0">
          <div className="col">
            {pageType === PageFor.GENERAL ? (
              <>
                {state.empSubType === empType.SYS_ADMIN ? (
                  <Button
                    mode={"excel"}
                    type="button"
                    onClick={() => {
                      setImportModal(!importModal);
                    }}
                  >
                    Import
                  </Button>
                ) : null}
                <Button
                  onClick={() => {
                    if (state.empSubType === empType.PMU)
                      navigate(`/${customer_id}/junctions/changepriority`);
                    else
                      navigate(
                        `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/site/${siteID}/junctions/view`
                      );
                  }}
                >
                  <img src={Next} alt="" />
                  Change Priority
                </Button>
                {print ? (
                  <Button
                    mode="print"
                    onClick={() => setPrintModal(!printModal)}
                  >
                    {" "}
                    Preview
                  </Button>
                ) : (
                  <Button mode="print" onClick={() => setPrint(!print)} />
                )}

                <Button
                  mode="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
              </>
            ) : (
              <Button mode="cancel" onClick={() => setModalFlag(false)} />
            )}
          </div>
          <div className="col flex-end">
            <div className="overall-total-count">
              Total Count : <b>{data?.GetJunctions.totalCount}</b>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={
          <AddJunctions
            setModalFlag={setAddModal}
            operation={Operation.CREATE}
          />
        }
        style={ViewAssetStyles}
      />
      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={
          <AddJunctions
            setModalFlag={setEditModal}
            operation={Operation.UPDATE}
          />
        }
        style={ViewAssetStyles}
      />

      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={
          <AddJunctions
            setModalFlag={setEditModal}
            operation={Operation.UPDATE}
          />
        }
        style={ViewAssetStyles}
      />
      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(!viewModal)}
        contentComponent={
          <ParticuarJunctionDetails setModalFlag={setViewModal} />
        }
        style={ViewAssetStyles}
      />
      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={
          <ImportJunctions
            setModalFlag={setImportModal}
            NavType={LicenseTypes.COMPANY}
            pageType={PageFor.MODAL}
          />
        }
        style={CustomModalStyles}
      />
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <DeleteModal
        id={0}
        setModalFlag={setDeleteModal}
        modalFlag={deleteModal}
        handleDelete={HandleDelete}
      />
      <LoadingModal
        flag={(!searchData && loading) || DeleteSubsidiarySiteLoading}
      />

      <CustomModal
        isOpen={printModal}
        onRequestClose={() => setPrintModal(!printModal)}
        contentComponent={
          <PrintJunctionDetails
            setModalFlag={setPrintModal}
            selectedJunctions={selectedJunctions}
          />
        }
        style={PrintModalStyles}
      />
    </>
  );
};

export default Junctions;
